import { TaskState } from 'firebase/storage';
import { useCareTeamSelector } from './useCareTeamSelector';
import { useCallback } from 'react';

export const useUploadProgress = (
  channelGuid: string,
  messageGuid: string,
): [TaskState, number?] | null => {
  return useCareTeamSelector(
    useCallback(
      (state) => {
        if (state === 'LOADING') {
          return null;
        }
        const fileUpload = state.fileUploads[channelGuid]?.[messageGuid];
        return fileUpload ? [fileUpload.state, fileUpload.progress] : null;
      },
      [channelGuid, messageGuid],
    ),
  );
};
